export const NAVIGATION_RAIL_HORIZONTAL_PADDING = 20;
